module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_wayo_studio-4c5a28d0bd1fe944291eca8542e8b966.webp";